<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     :style="'background-image: url('+configData.company_banner+')'">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100"
                          ref="form"
                          data-url="/user/register"
                    >
                        <div class="text-center mb-4">
                            <img :src="configData.company_logo?configData.company_logo:'/images/core.png'" alt=""
                                 class="img-fluid logo">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <h6 class="text-center mb-0">{{ $t('sign_up') }}</h6>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="referral_code">{{ $t('referral_code') }}</label>
                                <app-input type="text"
                                           id="referral_code"
                                           v-model="user.referral_code"
                                           :placeholder="$t('enter_referral_code')"
                                           :error-message="$errorMessage(errors, 'referral_code')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="user_first_name">{{ $t('name') }}</label>
                                <app-input type="text"
                                           id="user_first_name"
                                           v-model="user.name"
                                           :placeholder="$t('enter_your_name')"
                                           :required="true"
                                           :error-message="$errorMessage(errors, 'first_name')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="phone">{{ $t('phone') }}</label>
                                <vue-tel-input
                                        id="phone"
                                        :placeholder="$t('enter_your_phone')"
                                        styleClasses="default-font-color"
                                        @input="phoneInput"
                                        :autoFormat="false"
                                        autocomplete="off"
                                        :input-options="{
                                        autocomplete: false,
                                        autoFormat: false
                                    }"
                                />
                                <span v-if="$errorMessage(errors, 'phone')" class="text-danger">
                                    {{ $errorMessage(errors, 'phone') }}
                                </span>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label>{{ $t('date_of_birth') }}</label>
                                <div class="form-inline">
                                    <app-input type="select"
                                               v-model="user.day"
                                               :list="days"
                                               :required="true"
                                    />

                                    <app-input type="select"
                                               v-model="user.month"
                                               :list="months"
                                               class="ml-5"
                                               :required="true"
                                    />

                                    <app-input type="select"
                                               v-model="user.year"
                                               :list="years"
                                               class="ml-5"
                                               :required="true"
                                    />

                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="nid">{{ $t('nid') }}</label>
                                <app-input type="text"
                                           id="nid"
                                           v-model="user.nid"
                                           :placeholder="$t('enter_your_nid')"
                                           :error-message="$errorMessage(errors, 'nid')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="email">{{ $t('email') }}</label>
                                <app-input type="email"
                                           id="email"
                                           v-model="user.email"
                                           :placeholder="$t('enter_your_email')"
                                           :error-message="$errorMessage(errors, 'email')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="district">{{ $t('address') }}</label>
                                <app-input
                                        type="textarea"
                                        id="address"
                                        v-model="user.address"
                                        placeholder="Enter your address"
                                        :error-message="$errorMessage(errors, 'address')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="district">{{ $t('district') }}</label>
                                <app-input
                                        type="search-select"
                                        id="district"
                                        v-model="user.district_id"
                                        :list="selectableDistrict"
                                        list-value-field="name"
                                        :error-message="$errorMessage(errors, 'district_id')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="thana">{{ $t('thana') }}</label>
                                <app-input
                                        type="search-select"
                                        id="thana"
                                        v-model="user.thana_id"
                                        :list="selectableThanas"
                                        list-value-field="name"
                                        :error-message="$errorMessage(errors, 'thana_id')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="user_password">
                                    {{ $t('password') }}
                                </label>
                                <app-input type="password"
                                           id="user_password"
                                           v-model="user.password"
                                           :placeholder="$t('enter_your_password')"
                                           :required="true"
                                           :error-message="$errorMessage(errors, 'password')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <label for="user_password_confirmation">{{ $t('confirm_password') }}</label>
                                <app-input type="password"
                                           id="user_password_confirmation"
                                           same-as="user_password"
                                           v-model="user.password_confirmation"
                                           :placeholder="$t('confirm_password')"
                                           :required="true"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 mb-3">
                                <app-load-more :preloader="preloader"
                                               :label="$t('sign_up')"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div>
                        <div class="form-row mt-3">
                            <div class="col-12 d-flex align-items-center">
                                <p>Already have an account? <a href="/admin/users/login">Login</a> here</p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') + configData.company_name }}
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import {VueTelInput} from "vue-tel-input";
    import 'vue-tel-input/dist/vue-tel-input.css'
    import moment from 'moment';
    import {range} from '../../../Helpers/Helpers'
    import {numberOfDays} from '../../../Helpers/DateTimeHelper'

    export default {
        name: "Registration",
        mixins: [AuthMixin, ThemeMixin, FormHelperMixin],
        components: {
            VueTelInput
        },
        props: {
            districts: {},
            thanas: {},
            redirect: {}
        },
        data() {
            return {
                user: {
                    name: '',
                    year: Number(moment(moment.now()).format('YYYY')) - 5,
                    month: moment(moment.now()).format('MM'),
                    day: moment(moment.now()).format('DD'),
                    district_id: null
                },
                userData: {},
            }
        },
        methods: {
            submit() {
                this.save({
                    ...this.user,
                    ...this.names,
                    date_of_birth: `${this.user.year}-${this.user.month}-${this.user.day}`
                });
            },
            afterSuccess({data}) {
                this.$toastr.s(data.message);
                if (Boolean(data.isLoggedIn) && Boolean(this.redirect)) {
                    return window.location = `/${this.redirect}`;
                }
                location.replace(`/admin/users/login?redirect=${this.redirect}`);
            },
            phoneInput(value, country) {
                this.user.phone = value;
                this.user.country_code = `+${country.country.dialCode}`
            }
        },
        computed: {
            names() {
                const full_name_spited = this.user.name.split(' ').filter(name => name);
                if (full_name_spited.length) {
                    if (full_name_spited.length === 2) {
                        return {
                            first_name: full_name_spited[0],
                            last_name: full_name_spited[1]
                        }
                    } else if (full_name_spited.length === 1) {
                        return {
                            first_name: full_name_spited[0],
                            last_name: ''
                        }
                    } else if (full_name_spited.length === 3) {
                        return {
                            first_name: `${full_name_spited[0]} ${full_name_spited[1]}`,
                            last_name: full_name_spited[2]
                        }
                    } else {
                        return {
                            first_name: full_name_spited[0],
                            last_name: full_name_spited.slice(1, full_name_spited.length).join(' ')
                        }
                    }
                }
                return {
                    first_name: '',
                    last_name: ''
                }
            },
            months() {
                return [
                    {
                        id: '01',
                        value: "January"
                    },
                    {
                        id: '02',
                        value: "February"
                    },
                    {
                        id: '03',
                        value: "March"
                    },
                    {
                        id: '04',
                        value: "April"
                    },
                    {
                        id: '05',
                        value: "May"
                    },
                    {
                        id: '06',
                        value: "June"
                    },
                    {
                        id: '07',
                        value: "July"
                    },
                    {
                        id: '08',
                        value: "August"
                    },
                    {
                        id: '09',
                        value: "September"
                    },
                    {
                        id: 10,
                        value: "October"
                    },
                    {
                        id: 11,
                        value: "November"
                    },
                    {
                        id: 12,
                        value: "December"
                    }
                ];
            },
            years() {
                const currentYear = Number(moment(moment.now()).format('YYYY')) - 4;
                return range(1, 150).map(year => ({
                    id: currentYear - year,
                    value: currentYear - year
                }));
            },
            days() {
                const end = this.user.year && this.user.month ?
                    numberOfDays(this.user.year, this.user.month) : 31;

                return range(1, end).map(r => ({
                    id: Number(r) < 10 ? `0${r}` : r,
                    value: Number(r) < 10 ? `0${r}` : r,
                }))
            },
            selectableDistrict() {
                return [
                    {id: null, name: 'Select a district', disabled: true},
                    ...this.districts
                ];
            },
            selectableThanas() {
                const thanas = this.user.district_id ?
                    this.thanas.filter(thana => Number(thana.district_id) === Number(this.user.district_id))
                    : this.thanas;
                return [
                    {id: null, name: 'Select a thana', disabled: true},
                    ...thanas
                ];
            },
        },
    }
</script>
